// extracted by mini-css-extract-plugin
export default {"audioInstructions":"Aj5cCg0MX630pOeDxVA8"};